export enum PermissionStatus {
  PENDING = 'PENDING',     // Beklemede
  APPROVED = 'APPROVED',   // Onaylandı
  REJECTED = 'REJECTED',    // Reddedildi
  CANCELLED = 'CANCELLED'
} 